import { Button, Link } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { useSiteData } from '../../hooks/useSiteData';

export const ContinueShopping = () => {
  const { externalAppNavigation } = useSiteData();
  const [emptyOrderHistory = {}] = useTranslations(['emptyOrderHistory']);
  return (
    <Button
      render={(p) => (
        <Link href={externalAppNavigation.base} className={p.className}>
          {p.children}
        </Link>
      )}
      skin="primary"
      mb={7}
    >
      {emptyOrderHistory.continueShopping}
    </Button>
  );
};
